import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import { PhotoIcon, VideoCameraIcon, DocumentIcon } from '@heroicons/react/24/outline';

const FileUpload = ({ accept, multiple = false, maxSize = 10 * 1024 * 1024, onFileSelect }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    
    // 파일 크기 체크
    const oversizedFiles = files.filter(file => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      toast.error(`파일 크기는 ${maxSize / 1024 / 1024}MB를 초과할 수 없습니다.`);
      return;
    }
    
    // 파일 타입 체크
    if (accept) {
      const acceptedTypes = accept.split(',').map(type => type.trim());
      const invalidFiles = files.filter(file => {
        return !acceptedTypes.some(type => {
          if (type.startsWith('.')) {
            return file.name.toLowerCase().endsWith(type.toLowerCase());
          }
          if (type.endsWith('/*')) {
            return file.type.startsWith(type.slice(0, -1));
          }
          return file.type === type;
        });
      });
      
      if (invalidFiles.length > 0) {
        toast.error('허용되지 않는 파일 형식입니다.');
        return;
      }
    }
    
    onFileSelect(files);
    
    // 입력 초기화
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const getIcon = () => {
    if (accept?.includes('image')) return <PhotoIcon className="h-5 w-5" />;
    if (accept?.includes('video')) return <VideoCameraIcon className="h-5 w-5" />;
    return <DocumentIcon className="h-5 w-5" />;
  };

  return (
    <div className="w-full">
      <label className="flex items-center justify-center w-full px-4 py-3 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer hover:border-gray-400 transition-colors">
        <div className="flex items-center gap-2 text-gray-600">
          {getIcon()}
          <span className="text-sm font-medium">
            {multiple ? '파일 선택' : '파일 선택'}
          </span>
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
    </div>
  );
};

export default FileUpload;